export default __webpack_public_path__ + "static/loaded_truck2-918665dea963cef418bd817dbcc29d29.jpg";